module.exports = __webpack_public_path__ + "static/media/nav-fb-share.42b96221.svg";